import React, { Component } from 'react'
import { Button, Col, Row } from 'reactstrap'
import Card from '../../../../comum/components/Card'
import RadiobuttonGroup from '../../../../comum/components/RadiobuttonGroup'
import FormInputSimples from '../../../../comum/components/FormInputSimples'
import { observer } from 'mobx-react'
import LoadingImage from '../../../../comum/components/LoadingImage'

@observer
export default class FiltrosOrcamentoExport extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller

    }

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        {
                            this.controller.loadingTipos
                            ?<LoadingImage />
                            :<RadiobuttonGroup  xs={12} sm={12} md={7} lg={6} xl={5}
                                titulo="Predefinições"
                                name="predefinicoes"
                                onClick={this.controller.setPredefinicoes}
                                itens={this.controller.listaTipos}
    
                            />
                        }
                        <FormInputSimples  xs={12} sm={12} md={3} lg={4} xl={2}
                            titulo="Documento"
                            onEnter={this.controller.pesquisar}
                            dado={this.controller.documento}
                            onChange={this.controller.setDocumento}
                        />
                        <Col className="col-botoes"  xs={12} sm={12} md={2} lg={4} xl={2}>
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={this.controller.pesquisar}>Processar</Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/exportacao/components/FiltrosOrcamentoExport.js